/**
 * @package
 */
export const themeBorderRadius = {
  DEFAULT: '5px',
  small: '2px',
  none: '0px'
} as const;
